// Date formatting constants
export const PADSTART_INDEX = 2;

// Index constants
export const FIRST_INDEX = 0;
export const SECOND_INDEX = 1;

// Opacity levels
export const FULL_OPACITY = 1;
export const MEDIUM_OPACITY = 0.8;

// Chart configuration constants
export const PERCENTAGE = 100;
export const MAX_VALUE_LENGTH = 10;
export const STROKE_WIDTH = 3;
export const SHOW_LABEL_WIDTH = 1300;

// Padding constants
export const RIGHT_PADDING = 50;
export const LEFT_PADDING = 50;

// Store pagination constants
export const STORE_LIMIT = 10;
export const DEFAULT_MAX_SERIES_PER_PAGE = 5;
export const LAST_PAGE_INDEX = -1;

